"use client"

import { useTimeSlots } from "@/hooks/use-time-slots"
import SlotsGrid from "@/components/slots-grid"
import SlotsSkeleton from "@/components/slots-skeleton"
import { AlertCircle, RefreshCcw } from "lucide-react"
import { useTranslation } from "react-i18next"

export default function SlotsGridContainer({
  branchId,
  serviceId,
  appointmentDate,
}: {
  branchId: string
  serviceId: string
  appointmentDate: string
}) {
  const { data: slots = [], isLoading, error, refetch } = useTimeSlots(branchId, serviceId, appointmentDate)
  const { t } = useTranslation()

  // Branch IDs with extended hours until 20:00
  const extendedBranchIds = [
    "90e302ff-3fb1-4da5-9a98-98e7653ed81e", // Ledeta
    "f568edee-7fed-499e-968f-6f237adb0485", // Megenagna
    "863a1ca3-71e4-4c10-8b05-5dfdbfdce39f", // Megenagna VIP
  ]

  // Determine cutoff time based on branch
  const cutoffTime = extendedBranchIds.includes(branchId) ? "20:00:00" : "17:00:00"

  // Filter slots strictly less than cutoff
  const filteredSlots = slots ? slots.filter(slot => slot.time_from < cutoffTime) : []

  console.log(`Filtered slots for branch ${branchId} (cutoff ${cutoffTime}):`, filteredSlots, slots)

  if (isLoading) return <SlotsSkeleton />

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center py-12 px-4 text-center animate-fade-in-up">
        <div className="w-16 h-16 rounded-full bg-red-50 flex items-center justify-center mb-4 shadow-inner">
          <AlertCircle className="w-8 h-8 text-red-400" />
        </div>
        <h3 className="text-base font-bold text-gray-900 mb-2">{t("Failed to load slots")}</h3>
        <p className="text-gray-500 text-sm max-w-xs mx-auto mb-6">
          {t("Something went wrong while fetching available times. Please try again.")}
        </p>
        <button
          onClick={() => refetch()}
          className="flex items-center gap-2 px-5 py-2 bg-pink-600 text-white rounded-full text-sm font-bold hover:bg-gray-800 hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300 active:scale-95"
        >
          <RefreshCcw size={14} />
          {t("Try Again")}
        </button>
      </div>
    )
  }

  return <SlotsGrid slots={filteredSlots} selectedDate={appointmentDate} />
}




